export const RQ_GET_USER_API = {
  url: 'api/user/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_GET_USER_DETAILS_API = {
  url: 'api/user/<%= id %>/lookup',
  method: 'GET',
  auth: true,
};
